// extracted by mini-css-extract-plugin
module.exports = {"root":"BasicModal_root__Bi08z","buttonClose":"BasicModal_buttonClose__2g4p0"};